<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-inexorange hover:text-white" :href="route('contacts')">Formulario de Inicio</inertia-link>
      <span class="text-white font-medium">, para iniciar debes llenar la siguiente información</span>
    </h1>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.ruc" :error="form.errors.ruc" class="pr-6 pb-8 w-full lg:w-1/3" label="CI/Pasaporte" required/>
          <text-input v-model="form.nombres" :error="form.errors.nombres" class="pr-6 pb-8 w-full lg:w-1/3" label="Nombres" required/>
          <text-input v-model="form.apellidos" :error="form.errors.apellidos" class="pr-6 pb-8 w-full lg:w-1/3" label="Apellidos" required/>
          <select-input v-model="form.genero" :error="form.errors.genero" class="pr-6 pb-8 w-full lg:w-1/3" label="Genero" >
              <option>Femenino</option>  
            <option>Masculino</option>
              <option>Prefiero no decirlo</option>
          </select-input>
          <text-input v-model="form.ciudad" :error="form.errors.ciudad" class="pr-6 pb-8 w-full lg:w-1/3" label="Ciudad" required/>
          <text-input v-model="form.direccion" :error="form.errors.direccion" class="pr-6 pb-8 w-full lg:w-1/3" label="Dirección" required/>
          <text-input v-model="form.telefono" :error="form.errors.telefono" class="pr-6 pb-8 w-full lg:w-1/3" label="Telefono" required/>
          <text-input type="date" v-model="birthay" :error="form.errors.birthay" class="pr-6 pb-8 w-full lg:w-1/3" label="Fecha de Nacimeinto" required/>
         <select-input v-model="form.nivel" :error="form.errors.nivel" class="pr-6 pb-8 w-full lg:w-1/3" label="Nivel de juego" >
              <option>Principiante</option>
              <option>Intermedio</option>
              <option>Avanzado</option>
          </select-input>
          <select-input v-model="form.mano" :error="form.errors.mano" class="pr-6 pb-8 w-full lg:w-1/3" label="Mano Dominante" >
              <option>Derecha</option>
              <option>Izquierda</option>
              <option>Ambidiestro</option>
          </select-input>
          <text-input v-model="form.club" :error="form.errors.club" class="pr-6 pb-8 w-full lg:w-1/3" label="Club o cancha donde juegas" />
          <text-input v-model="form.entrenador" :error="form.errors.entrenador" class="pr-6 pb-8 w-full lg:w-1/3" label="Nombre Entrenador" />
          <select-input v-model="form.posicion" :error="form.errors.posicion" class="pr-6 pb-8 w-full lg:w-1/3" label="Posición de juego" required>
              <option>Driver</option>
              <option>Reves</option>
              <option>Ambos</option>
          </select-input>
           <select-input v-model="form.categoria" :error="form.errors.categoria" class="pr-6 pb-8 w-full lg:w-1/3" label="Categoría que perteneces" required>
              <option>6ta</option>
              <option>5ta</option>
              <option>4ta</option>
              <option>3ra</option>
              <option>2da</option>
              <option>1ra</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-transparent flex justify-end items-center">
          <loading-button :loading="form.processing" style="color: white" class="px-8 py-4 btn-indigoOrange" type="submit">Agregar Datos</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Agregar Cliente' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    users: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        ruc: null,
        genero:null,
        nombres: null,
        apellidos: null,
        ciudad: null,
        direccion: null,
        telefono: null,
        type: null,
        birthay: null,
        verification: null,
        nivel: null,
        mano: null,
        club: null,
        entrenador: null,
        posicion: null,
        categoria: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('contacts.store'))
    },
  },
}
</script>
